const xrdJcamp2 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=X-RAY DIFFRACTION
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##FIRSTX=2.0000
##LASTX=19.9993
##MINX=2.0
##MAXX=19.9993
##MINY=6.4335
##MAXY=1084.5697
##NPOINTS=928
##FIRSTY=48.6612
##XUNITS=1/CM
##YUNITS=COUNTS
##XYDATA=(XY..XY)
2.0000, 48.6612
2.0194, 48.6853
2.0388, 47.2395
2.0583, 45.4324
2.0777, 45.1191
2.0971, 42.3602
2.1165, 43.6372
2.1359, 41.2277
2.1553, 39.3121
2.1748, 38.7940
2.1942, 39.5048
2.2136, 38.4808
2.2330, 37.8904
2.2524, 37.1194
2.2718, 35.4929
2.2913, 36.2278
2.3107, 34.6977
2.3301, 34.6255
2.3495, 33.2279
2.3689, 33.0111
2.3883, 32.5171
2.4078, 32.8303
2.4272, 32.4448
2.4466, 32.5171
2.4660, 31.4087
2.4854, 32.0713
2.5048, 30.9027
2.5243, 31.2400
2.5437, 31.5171
2.5631, 30.9991
2.5825, 30.7340
2.6019, 30.8906
2.6213, 32.4087
2.6408, 31.7701
2.6602, 32.4569
2.6796, 33.3002
2.6990, 33.1195
2.7184, 33.2038
2.7378, 33.8785
2.7573, 34.0472
2.7767, 35.2279
2.7961, 35.7459
2.8155, 37.7338
2.8349, 38.3964
2.8543, 40.4566
2.8738, 41.3361
2.8932, 44.7577
2.9126, 45.1914
2.9320, 48.7576
2.9514, 51.6009
2.9708, 57.1067
2.9903, 61.3114
3.0097, 67.2510
3.0291, 72.9737
3.0485, 82.9252
3.0679, 93.0454
3.0873, 102.3584
3.1068, 117.5025
3.1262, 134.6947
3.1456, 153.0315
3.1650, 182.8017
3.1844, 232.4388
3.2038, 309.4726
3.2233, 436.5892
3.2427, 602.8975
3.2621, 803.0240
3.2815, 983.2836
3.3009, 1084.5697
3.3203, 1079.8590
3.3398, 943.3691
3.3592, 750.4954
3.3786, 532.1044
3.3980, 349.4834
3.4174, 227.0775
3.4368, 156.4772
3.4563, 118.7555
3.4757, 99.4187
3.4951, 88.1660
3.5145, 76.7808
3.5339, 67.4317
3.5533, 58.7091
3.5728, 53.2755
3.5922, 47.9745
3.6116, 44.1673
3.6310, 41.5771
3.6504, 37.1555
3.6698, 35.1194
3.6893, 33.7460
3.7087, 32.9629
3.7281, 30.9750
3.7475, 29.4690
3.7669, 28.2281
3.7863, 27.8305
3.8058, 26.5775
3.8252, 26.1558
3.8446, 24.1559
3.8640, 23.7704
3.8834, 23.8547
3.9028, 22.1319
3.9223, 21.7825
3.9417, 22.1921
3.9611, 21.2283
3.9805, 18.6380
3.9999, 19.4452
4.0193, 19.2404
4.0388, 19.2404
4.0582, 18.5175
4.0776, 18.3970
4.0970, 18.3007
4.1164, 17.9151
4.1358, 17.4332
4.1553, 16.8790
4.1747, 16.3730
4.1941, 15.6019
4.2135, 15.9393
4.2329, 14.8188
4.2523, 15.0116
4.2718, 14.2044
4.2912, 14.3731
4.3106, 13.9634
4.3300, 14.1923
4.3494, 14.0237
4.3688, 13.4695
4.3883, 13.1080
4.4077, 13.4092
4.4271, 12.5779
4.4465, 13.0719
4.4659, 12.2285
4.4853, 12.1924
4.5048, 12.4575
4.5242, 12.3490
4.5436, 12.3731
4.5630, 12.0358
4.5824, 11.5780
4.6018, 11.2045
4.6213, 11.0238
4.6407, 10.9515
4.6601, 11.0961
4.6795, 10.6623
4.6989, 10.3491
4.7183, 10.2768
4.7378, 9.8913
4.7572, 10.1563
4.7766, 10.5659
4.7960, 10.3732
4.8154, 10.0840
4.8348, 10.5659
4.8543, 10.4937
4.8737, 10.3250
4.8931, 10.4214
4.9125, 10.1804
4.9319, 10.0358
4.9513, 9.4455
4.9708, 9.4816
4.9902, 10.3009
5.0096, 9.6624
5.0290, 9.9395
5.0484, 9.5419
5.0678, 10.3250
5.0873, 9.5178
5.1067, 9.4094
5.1261, 9.3371
5.1455, 9.2648
5.1649, 9.7949
5.1843, 10.0599
5.2038, 9.4094
5.2232, 9.4816
5.2426, 8.9997
5.2620, 9.2889
5.2814, 9.1684
5.3008, 9.2407
5.3203, 8.7829
5.3397, 9.3371
5.3591, 9.0720
5.3785, 9.3732
5.3979, 9.5539
5.4173, 8.9756
5.4368, 8.5781
5.4562, 8.9274
5.4756, 9.5901
5.4950, 9.0600
5.5144, 9.5901
5.5338, 8.8311
5.5533, 9.2527
5.5727, 8.9756
5.5921, 9.2166
5.6115, 9.1202
5.6309, 9.1082
5.6503, 9.0118
5.6698, 8.7708
5.6892, 9.7467
5.7086, 9.4575
5.7280, 9.1443
5.7474, 8.9154
5.7668, 9.4214
5.7863, 9.4575
5.8057, 8.6503
5.8251, 9.1202
5.8445, 9.1202
5.8639, 9.3130
5.8833, 10.0117
5.9028, 10.1563
5.9222, 10.1684
5.9416, 10.6141
5.9610, 10.1804
5.9804, 10.1684
5.9998, 9.8913
6.0193, 10.7708
6.0387, 10.4093
6.0581, 10.8792
6.0775, 11.2527
6.0969, 11.6382
6.1163, 11.5539
6.1358, 12.3972
6.1552, 13.0478
6.1746, 13.3851
6.1940, 14.6140
6.2134, 15.0116
6.2328, 16.5658
6.2523, 17.7224
6.2717, 18.9994
6.2911, 21.0717
6.3105, 24.0475
6.3299, 27.6136
6.3493, 30.6738
6.3688, 34.0954
6.3882, 39.8904
6.4076, 43.6854
6.4270, 51.0105
6.4464, 64.5884
6.4658, 82.3590
6.4853, 111.8400
6.5047, 150.3690
6.5241, 198.9217
6.5435, 235.0772
6.5629, 252.5948
6.5823, 251.9683
6.6018, 223.9330
6.6212, 172.7056
6.6406, 124.4661
6.6600, 83.0818
6.6794, 54.3839
6.6988, 39.1554
6.7183, 31.5774
6.7377, 27.5293
6.7571, 24.6740
6.7765, 22.7463
6.7959, 19.8428
6.8153, 17.8790
6.8348, 16.7947
6.8542, 14.6863
6.8736, 13.8189
6.8930, 13.9393
6.9124, 13.8550
6.9318, 12.4454
6.9513, 12.2767
6.9707, 11.6141
6.9901, 11.0479
7.0095, 11.0479
7.0289, 11.4454
7.0483, 11.6984
7.0678, 10.9515
7.0872, 10.4455
7.1066, 10.6503
7.1260, 10.6141
7.1454, 10.7828
7.1648, 10.0720
7.1843, 10.2768
7.2037, 10.1081
7.2231, 10.0238
7.2425, 10.0720
7.2619, 9.8551
7.2813, 9.3612
7.3008, 8.9636
7.3202, 9.5660
7.3396, 9.6021
7.3590, 9.1323
7.3784, 9.1082
7.3978, 9.6021
7.4173, 9.3130
7.4367, 9.0600
7.4561, 9.0359
7.4755, 9.2045
7.4949, 9.3250
7.5143, 9.2407
7.5338, 9.3371
7.5532, 8.5901
7.5726, 8.6624
7.5920, 9.5178
7.6114, 7.7949
7.6308, 8.7106
7.6503, 9.1564
7.6697, 8.3491
7.6891, 8.8793
7.7085, 8.3010
7.7279, 8.6985
7.7473, 8.4696
7.7668, 7.9757
7.7862, 7.8672
7.8056, 8.6744
7.8250, 8.2648
7.8444, 8.3853
7.8638, 7.8672
7.8833, 8.5781
7.9027, 8.0359
7.9221, 8.2528
7.9415, 8.4937
7.9609, 8.1443
7.9803, 8.0480
7.9998, 8.1443
8.0192, 8.4937
8.0386, 8.4214
8.0580, 7.9636
8.0774, 8.2287
8.0968, 8.4455
8.1163, 8.2407
8.1357, 8.0720
8.1551, 8.1443
8.1745, 8.1323
8.1939, 7.7588
8.2133, 8.1684
8.2328, 8.0118
8.2522, 7.9154
8.2716, 8.2648
8.2910, 7.9275
8.3104, 8.2769
8.3298, 7.9034
8.3493, 7.9757
8.3687, 7.4576
8.3881, 7.8311
8.4075, 7.7347
8.4269, 8.1202
8.4463, 7.8672
8.4658, 7.2648
8.4852, 7.4456
8.5046, 7.5781
8.5240, 7.1805
8.5434, 7.5419
8.5628, 7.7949
8.5823, 7.7347
8.6017, 7.3853
8.6211, 7.6022
8.6405, 7.3853
8.6599, 7.5781
8.6793, 7.9275
8.6988, 7.2407
8.7182, 7.1323
8.7376, 7.9636
8.7570, 7.8552
8.7764, 7.7468
8.7958, 7.4215
8.8153, 7.6624
8.8347, 7.2769
8.8541, 8.0600
8.8735, 7.4335
8.8929, 7.7347
8.9123, 7.5299
8.9318, 7.5299
8.9512, 8.2648
8.9706, 7.3130
8.9900, 7.7106
9.0094, 7.8190
9.0288, 7.3612
9.0483, 7.2769
9.0677, 7.6263
9.0871, 7.0359
9.1065, 7.0118
9.1259, 7.3010
9.1453, 7.6986
9.1648, 7.5178
9.1842, 7.7347
9.2036, 7.6142
9.2230, 7.0841
9.2424, 7.5299
9.2618, 7.2407
9.2813, 7.6142
9.3007, 7.5299
9.3201, 7.9395
9.3395, 7.4335
9.3589, 6.8311
9.3783, 7.5781
9.3978, 7.4937
9.4172, 7.8793
9.4366, 7.7588
9.4560, 7.8913
9.4754, 7.8190
9.4948, 8.1202
9.5143, 7.9516
9.5337, 7.6142
9.5531, 8.3732
9.5725, 8.3130
9.5919, 9.3250
9.6113, 8.5781
9.6308, 9.1202
9.6502, 9.0841
9.6696, 10.4214
9.6890, 10.5057
9.7084, 12.1683
9.7278, 13.2165
9.7473, 15.2526
9.7667, 17.3127
9.7861, 22.2764
9.8055, 25.3968
9.8249, 28.2040
9.8443, 29.7220
9.8638, 29.1798
9.8832, 25.6016
9.9026, 21.3006
9.9220, 16.4091
9.9414, 13.5779
9.9608, 11.6503
9.9803, 10.2527
9.9997, 9.4816
10.0191, 9.2648
10.0385, 8.5901
10.0579, 8.5419
10.0773, 8.4937
10.0968, 8.5299
10.1162, 8.0961
10.1356, 7.9034
10.1550, 8.0359
10.1744, 7.6504
10.1938, 7.0721
10.2133, 7.4576
10.2327, 8.0600
10.2521, 7.7949
10.2715, 7.7829
10.2909, 7.7468
10.3103, 7.5901
10.3298, 7.4937
10.3492, 7.5781
10.3686, 7.5781
10.3880, 6.9275
10.4074, 7.6383
10.4268, 7.4697
10.4463, 7.2407
10.4657, 6.8552
10.4851, 7.2046
10.5045, 8.1202
10.5239, 7.2528
10.5433, 7.5781
10.5628, 7.2287
10.5822, 6.9516
10.6016, 6.8311
10.6210, 7.3974
10.6404, 7.2769
10.6598, 7.6745
10.6793, 7.1685
10.6987, 7.2046
10.7181, 7.2166
10.7375, 7.5901
10.7569, 7.6986
10.7763, 7.3612
10.7958, 7.6022
10.8152, 7.0721
10.8346, 7.0962
10.8540, 7.5419
10.8734, 6.9516
10.8928, 7.0359
10.9123, 7.3612
10.9317, 6.9757
10.9511, 7.3974
10.9705, 7.3492
10.9899, 7.3733
11.0093, 7.2166
11.0288, 7.3371
11.0482, 7.4937
11.0676, 7.6263
11.0870, 7.1685
11.1064, 7.5781
11.1258, 7.5540
11.1453, 6.7709
11.1647, 7.1203
11.1841, 6.9155
11.2035, 6.4697
11.2229, 7.0721
11.2423, 7.4456
11.2618, 7.0239
11.2812, 6.7468
11.3006, 7.3010
11.3200, 6.9275
11.3394, 7.1323
11.3588, 7.1323
11.3783, 7.3130
11.3977, 7.2528
11.4171, 7.1444
11.4365, 6.9757
11.4559, 7.3733
11.4753, 7.1685
11.4948, 7.5540
11.5142, 7.7106
11.5336, 7.3733
11.5530, 7.0359
11.5724, 7.0841
11.5918, 6.7227
11.6113, 7.1082
11.6307, 7.7949
11.6501, 7.3251
11.6695, 6.7709
11.6889, 7.1444
11.7083, 7.2287
11.7278, 7.4817
11.7472, 6.9155
11.7666, 7.1444
11.7860, 7.6624
11.8054, 7.1203
11.8248, 7.3492
11.8443, 6.9155
11.8637, 6.7347
11.8831, 7.7588
11.9025, 6.7588
11.9219, 7.3371
11.9413, 6.6022
11.9608, 6.7106
11.9802, 7.1926
11.9996, 7.3733
12.0190, 7.3733
12.0384, 7.4094
12.0579, 6.8914
12.0773, 7.3010
12.0967, 7.0962
12.1161, 6.8070
12.1355, 6.6384
12.1549, 7.3733
12.1744, 7.2648
12.1938, 6.7106
12.2132, 7.2648
12.2326, 7.5901
12.2520, 6.4697
12.2714, 6.7468
12.2909, 6.5058
12.3103, 6.7106
12.3297, 7.4576
12.3491, 7.2046
12.3685, 7.0359
12.3879, 7.1323
12.4074, 7.2528
12.4268, 7.3733
12.4462, 6.5058
12.4656, 6.9998
12.4850, 7.1203
12.5044, 6.7468
12.5239, 7.0359
12.5433, 7.5299
12.5627, 7.3853
12.5821, 6.7829
12.6015, 7.7588
12.6209, 7.3612
12.6404, 6.7950
12.6598, 7.5058
12.6792, 7.4937
12.6986, 6.7106
12.7180, 7.3612
12.7374, 7.3010
12.7569, 7.3974
12.7763, 7.4094
12.7957, 7.3612
12.8151, 7.1805
12.8345, 7.5058
12.8539, 7.8431
12.8734, 7.2407
12.8928, 7.3733
12.9122, 7.6504
12.9316, 7.4215
12.9510, 7.9877
12.9704, 7.6865
12.9899, 7.7227
13.0093, 8.4817
13.0287, 8.4937
13.0481, 9.4816
13.0675, 9.3732
13.0869, 10.8792
13.1064, 10.2888
13.1258, 11.6743
13.1452, 11.7466
13.1646, 11.2286
13.1840, 10.8190
13.2034, 9.3130
13.2229, 8.4455
13.2423, 8.4696
13.2617, 8.0841
13.2811, 7.6624
13.3005, 7.4094
13.3199, 7.2287
13.3394, 6.7588
13.3588, 7.3733
13.3782, 7.6142
13.3976, 7.4817
13.4170, 7.3974
13.4364, 6.9155
13.4559, 7.4817
13.4753, 7.4817
13.4947, 6.8432
13.5141, 7.3733
13.5335, 7.3612
13.5529, 7.2769
13.5724, 7.4335
13.5918, 6.4335
13.6112, 6.5299
13.6306, 7.7347
13.6500, 7.0841
13.6694, 7.1805
13.6889, 7.8793
13.7083, 7.2528
13.7277, 7.5660
13.7471, 7.3251
13.7665, 7.4094
13.7859, 6.9155
13.8054, 7.5058
13.8248, 7.5660
13.8442, 7.0480
13.8636, 7.3010
13.8830, 7.1323
13.9024, 7.1082
13.9219, 7.6022
13.9413, 7.2528
13.9607, 7.3974
13.9801, 7.6745
13.9995, 7.3733
14.0189, 7.4576
14.0384, 7.7588
14.0578, 7.0721
14.0772, 7.4697
14.0966, 7.2528
14.1160, 7.5781
14.1354, 7.1323
14.1549, 7.5058
14.1743, 7.0721
14.1937, 7.3853
14.2131, 7.7709
14.2325, 7.3130
14.2519, 6.6384
14.2714, 7.4456
14.2908, 7.6383
14.3102, 7.3371
14.3296, 7.4335
14.3490, 7.3130
14.3684, 7.2046
14.3879, 7.9034
14.4073, 7.6142
14.4267, 7.6745
14.4461, 7.6263
14.4655, 7.3612
14.4849, 7.6263
14.5044, 7.8672
14.5238, 7.5058
14.5432, 6.7588
14.5626, 7.2287
14.5820, 7.7949
14.6014, 7.6986
14.6209, 7.3492
14.6403, 7.4576
14.6597, 7.7106
14.6791, 7.6865
14.6985, 7.4576
14.7179, 7.3010
14.7374, 6.9998
14.7568, 7.6022
14.7762, 7.5299
14.7956, 7.7227
14.8150, 7.4215
14.8344, 7.6022
14.8539, 7.4335
14.8733, 8.3853
14.8927, 7.8672
14.9121, 7.2407
14.9315, 7.6865
14.9509, 7.5660
14.9704, 7.6865
14.9898, 8.3371
15.0092, 7.2889
15.0286, 7.7106
15.0480, 8.1805
15.0674, 7.4697
15.0869, 7.6504
15.1063, 7.3853
15.1257, 8.0480
15.1451, 7.6745
15.1645, 7.9757
15.1839, 7.8793
15.2034, 7.4094
15.2228, 8.1564
15.2422, 7.8793
15.2616, 8.4937
15.2810, 7.3251
15.3004, 7.7227
15.3199, 8.1323
15.3393, 8.0600
15.3587, 7.6022
15.3781, 7.3130
15.3975, 7.7347
15.4169, 8.1684
15.4364, 7.5299
15.4558, 8.3130
15.4752, 7.9757
15.4946, 7.5781
15.5140, 7.9275
15.5334, 7.8913
15.5529, 7.7709
15.5723, 7.8311
15.5917, 7.9154
15.6111, 8.3853
15.6305, 7.8070
15.6499, 8.0961
15.6694, 8.0118
15.6888, 7.8552
15.7082, 7.9636
15.7276, 7.8552
15.7470, 8.0480
15.7664, 8.6624
15.7859, 8.6503
15.8053, 7.6022
15.8247, 8.4576
15.8441, 8.4455
15.8635, 8.2046
15.8829, 7.5299
15.9024, 8.2769
15.9218, 8.3612
15.9412, 8.3853
15.9606, 8.5540
15.9800, 8.3853
15.9994, 9.1443
16.0189, 8.4817
16.0383, 8.6383
16.0577, 8.6744
16.0771, 8.6624
16.0965, 8.6142
16.1159, 8.9033
16.1354, 9.4937
16.1548, 8.5419
16.1742, 8.4214
16.1936, 8.5299
16.2130, 8.9515
16.2324, 9.5660
16.2519, 8.9756
16.2713, 9.9515
16.2907, 9.2768
16.3101, 9.4214
16.3295, 11.4695
16.3489, 11.7346
16.3684, 11.9274
16.3878, 13.1080
16.4072, 12.8309
16.4266, 13.1562
16.4460, 13.3731
16.4654, 13.6140
16.4849, 12.1442
16.5043, 11.3009
16.5237, 10.6985
16.5431, 9.7949
16.5625, 9.7587
16.5819, 9.2045
16.6014, 9.0118
16.6208, 8.9877
16.6402, 9.0720
16.6596, 9.4937
16.6790, 9.1202
16.6984, 9.3371
16.7179, 9.2407
16.7373, 9.5660
16.7567, 9.4335
16.7761, 8.7829
16.7955, 9.4094
16.8149, 8.7106
16.8344, 9.2527
16.8538, 9.5539
16.8732, 9.3371
16.8926, 8.7708
16.9120, 8.9756
16.9314, 9.8551
16.9509, 9.1082
16.9703, 9.7828
16.9897, 9.4455
17.0091, 9.3973
17.0285, 9.8069
17.0479, 9.3371
17.0674, 9.3371
17.0868, 8.9274
17.1062, 10.0840
17.1256, 9.7346
17.1450, 10.1925
17.1644, 9.5660
17.1839, 9.3973
17.2033, 9.5178
17.2227, 9.3612
17.2421, 9.5298
17.2615, 9.6021
17.2809, 9.2286
17.3004, 9.3973
17.3198, 9.5660
17.3392, 10.1804
17.3586, 9.1564
17.3780, 10.1925
17.3974, 10.2166
17.4169, 10.2045
17.4363, 9.6865
17.4557, 9.8551
17.4751, 9.7226
17.4945, 9.7467
17.5139, 9.9274
17.5334, 9.8913
17.5528, 10.0720
17.5722, 9.6865
17.5916, 10.0238
17.6110, 9.8792
17.6304, 10.0961
17.6499, 9.7226
17.6693, 9.6985
17.6887, 9.6021
17.7081, 9.7106
17.7275, 9.9636
17.7469, 9.9274
17.7664, 9.8431
17.7858, 9.9636
17.8052, 10.4696
17.8246, 9.9154
17.8440, 9.9877
17.8634, 10.3009
17.8829, 9.2768
17.9023, 9.8792
17.9217, 10.1563
17.9411, 10.7587
17.9605, 10.9394
17.9799, 10.9635
17.9994, 11.0117
18.0188, 10.0479
18.0382, 10.4816
18.0576, 10.4455
18.0770, 11.1804
18.0964, 11.2888
18.1159, 10.7226
18.1353, 10.2407
18.1547, 11.2647
18.1741, 11.3972
18.1935, 11.0358
18.2129, 11.4695
18.2324, 11.1442
18.2518, 10.7708
18.2712, 11.4093
18.2906, 10.8310
18.3100, 11.4213
18.3294, 10.8671
18.3489, 11.3972
18.3683, 11.4816
18.3877, 11.3250
18.4071, 11.0599
18.4265, 11.7466
18.4459, 11.6864
18.4654, 11.3250
18.4848, 11.3852
18.5042, 11.6021
18.5236, 11.7105
18.5430, 11.4093
18.5624, 11.2165
18.5819, 11.6743
18.6013, 11.8310
18.6207, 12.4213
18.6401, 12.0719
18.6595, 11.6021
18.6789, 11.6984
18.6984, 11.6864
18.7178, 12.4936
18.7372, 11.8430
18.7566, 11.9274
18.7760, 12.2406
18.7954, 11.9876
18.8149, 11.4936
18.8343, 11.9635
18.8537, 12.1081
18.8731, 12.5538
18.8925, 12.4936
18.9119, 12.5900
18.9314, 11.8069
18.9508, 12.7105
18.9702, 12.1322
18.9896, 12.3852
19.0090, 12.4213
19.0284, 12.6261
19.0479, 11.6984
19.0673, 12.5297
19.0867, 11.9394
19.1061, 12.8309
19.1255, 11.9274
19.1449, 12.4936
19.1644, 12.1442
19.1838, 13.0598
19.2032, 13.0117
19.2226, 12.6623
19.2420, 13.3008
19.2614, 13.0117
19.2809, 12.8671
19.3003, 13.4574
19.3197, 12.6984
19.3391, 12.6502
19.3585, 13.1201
19.3779, 13.1683
19.3974, 12.3731
19.4168, 12.7225
19.4362, 12.9996
19.4556, 13.0237
19.4750, 12.1804
19.4944, 12.8671
19.5139, 13.5177
19.5333, 13.5297
19.5527, 12.2406
19.5721, 13.9273
19.5915, 12.9755
19.6109, 13.2406
19.6304, 13.5900
19.6498, 14.4092
19.6692, 14.0598
19.6886, 14.6020
19.7080, 15.0236
19.7274, 15.7465
19.7469, 15.2044
19.7663, 15.6140
19.7857, 15.2646
19.8051, 14.4574
19.8245, 14.6140
19.8439, 14.1442
19.8634, 14.5538
19.8828, 13.4936
19.9022, 14.0719
19.9216, 14.6020
19.9410, 14.2044
19.9604, 13.8791
19.9799, 13.7707
19.9993, 14.2767
##END=$$ End of the data block
`;

export default xrdJcamp2;
